import { SpecType } from '../types';

export const HPS_FILE_TYPES: Record<SpecType, { extension: string; label: string }> = {
  claimstatus30: { extension: '.cstat', label: 'Claim Status 3.0' },
  eligibility31: { extension: '.elig31', label: 'Eligibility 3.1' },
  eligibility30: { extension: '.elig30', label: 'Eligibility 3.0' },
  individualusagebenefit30: { extension: '.indi30', label: 'Individual Usage Benefit 3.0' },
  planbenefit30: { extension: '.plan30', label: 'Plan Benefit 3.0' },
  standardbenefitentity30: { extension: '.bene30', label: 'Standard Benefit Entity 3.0' },
};

export function getFileExtension(filename: string): string {
  const separator = filename.lastIndexOf('.');
  return separator >= 0 ? filename.slice(separator).toLowerCase() : '';
}
